import React from 'react';

function ShippingPolicy() {
  return (
    <div className="min-h-screen bg-[#0B0F17] text-gray-100 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
          Shipping Policy
        </h1>
        
        <div className="space-y-8 text-gray-400">

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Delivery Timeframe</h2>
            <p className="leading-relaxed">
              Access to the AI interviewer is typically granted instantly upon successful payment.  
              However, in rare cases, authentication may take up to a few hours. If access is not  
              granted immediately, please check again later or contact support.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Access and Authentication</h2>
            <p className="leading-relaxed">
              Once your payment is processed, you will be able to immediately access the interview.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Troubleshooting Access Issues</h2>
            <p className="leading-relaxed">
              If you experience delays beyond the expected timeframe, please try logging in again  
              or reaching out to our support team for assistance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Service Availability</h2>
            <p className="leading-relaxed">
              Our AI interviewer service is available 24/7. However, periodic maintenance or  
              unforeseen technical issues may cause temporary disruptions. We strive to minimize  
              downtime and will notify users of any scheduled maintenance in advance.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. User Responsibilities</h2>
            <p className="leading-relaxed">
              To ensure seamless access, users should provide a valid email address during registration  
              and maintain stable internet connectivity while using the service. We are not responsible  
              for issues arising from user-side technical difficulties.
            </p>
          </section>
  
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">5. Shipping Delays</h2>
            <p className="leading-relaxed">
              While we strive to meet all delivery timeframes, occasional delays may occur due to 
              unforeseen circumstances. We will notify you promptly of any significant delays.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default ShippingPolicy; 